// Utility helpers for category behaviors across the app

// Detect the system withdrawal category without relying on DB flags
// Heuristic: exact French label OR the factor combo used by withdrawal
// Keep strict label first to avoid false positives
export function isWithdrawalCategory(category) {
  if (!category) return false;
  const label = (category.label || '').trim();
  const hasWithdrawalLabel = label === 'Sortie Coffre';
  const hasWithdrawalFactors = Number(category.caisseFactor) === 0 && Number(category.coffreFactor) === -1;
  return hasWithdrawalLabel || hasWithdrawalFactors;
}



